// import React, { useEffect, useMemo, useRef, useState } from "react";
// import "./customerForm.css";
// import {
//   FiChevronRight,
//   FiX,
//   FiCheck,
//   FiImage,
//   FiUploadCloud,
// } from "react-icons/fi";

// import {
//   INDIAN_STATES,
//   STATE_DISTRICTS,
//   DISTRICT_TALUKS,
//   TALUK_PANCHAYATS,
// } from "./customerLocationData";

// const STATUS_OPTIONS = ["active", "blocked", "lead"];
// const API_BASE_URL =
//   process.env.REACT_APP_EP || "http://localhost:5000";

// const CustomerForm = ({ initialData, onCancel, onSave }) => {
//   const [form, setForm] = useState(initialData);
//   const [errors, setErrors] = useState({});
//   const [avatarFile, setAvatarFile] = useState(null); // actual file to upload
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [serverError, setServerError] = useState("");
//   const fileInputRef = useRef(null);

//   useEffect(() => {
//     setForm(initialData);
//     setErrors({});
//     setAvatarFile(null);
//     setServerError("");
//   }, [initialData]);

//   const districtOptions = useMemo(() => {
//     if (!form.state) return [];
//     return STATE_DISTRICTS[form.state] || [];
//   }, [form.state]);

//   const talukOptions = useMemo(() => {
//     if (!form.district) return [];
//     return DISTRICT_TALUKS[form.district] || [];
//   }, [form.district]);

//   const panchayatOptions = useMemo(() => {
//     if (!form.taluk) return [];
//     return TALUK_PANCHAYATS[form.taluk] || [];
//   }, [form.taluk]);

//   const handleChange = (field, value) => {
//     setForm((prev) => {
//       const updated = { ...prev, [field]: value };

//       // cascading resets
//       if (field === "state") {
//         updated.district = "";
//         updated.taluk = "";
//         updated.panchayat = "";
//       }
//       if (field === "district") {
//         updated.taluk = "";
//         updated.panchayat = "";
//       }
//       if (field === "taluk") {
//         updated.panchayat = "";
//       }

//       return updated;
//     });
//   };

//   const handleAvatarSelect = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = URL.createObjectURL(file);
//     setAvatarFile(file); // keep the file for upload
//     setForm((prev) => ({ ...prev, avatarUrl: url }));
//   };

//   const openFilePicker = () => {
//     fileInputRef.current?.click();
//   };

//   const validate = () => {
//     const err = {};

//     if (!form.name.trim()) err.name = "Customer name is required.";
//     if (!form.email.trim()) {
//       err.email = "Email is required.";
//     } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
//       err.email = "Enter a valid email.";
//     }

//     if (!form.phone.trim()) {
//       err.phone = "Phone number is required.";
//     } else if (!/^\d{10}$/.test(form.phone.replace(/\D/g, ""))) {
//       err.phone = "Enter a valid 10 digit phone number.";
//     }

//     if (!form.state) err.state = "State is required.";
//     if (!form.district) err.district = "District is required.";
//     if (!form.taluk) err.taluk = "Taluk is required.";
//     if (!form.panchayat) err.panchayat = "Panchayat is required.";

//     if (!form.pincode.trim()) {
//       err.pincode = "Pin code is required.";
//     } else if (!/^\d{6}$/.test(form.pincode.replace(/\D/g, ""))) {
//       err.pincode = "Enter a valid 6 digit pin code.";
//     }

//     return err;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const v = validate();
//     if (Object.keys(v).length) {
//       setErrors(v);
//       return;
//     }

//     setErrors({});
//     setServerError("");
//     setIsSubmitting(true);

//     try {
//       // Build multipart/form-data body
//       const formData = new FormData();

//       // Map frontend fields -> backend fields
//       formData.append("customer_name", form.name.trim());
//       formData.append("customer_email", form.email.trim());
//       formData.append("phone_number", form.phone.trim());
//       formData.append("customer_note", form.note || "");
//       formData.append("status", form.status || "active");
//       formData.append("state", form.state || "");
//       formData.append("district", form.district || "");
//       formData.append("taluk", form.taluk || "");
//       formData.append("panchayat", form.panchayat || "");
//       formData.append("landmark", form.landmark || "");
//       formData.append("pincode", form.pincode.trim());

//       if (avatarFile) {
//         // field name "image" must match uploadSingle('image')
//         formData.append("image", avatarFile);
//       }

//       // Determine create vs edit
//       const isEditing = Boolean(form.id || form.customer_id);
//       const id = form.id || form.customer_id;

//       const url = isEditing
//         ? `${API_BASE_URL}/api/customers/edit/${id}`
//         : `${API_BASE_URL}/api/customers/create`;
//       const method = isEditing ? "PATCH" : "POST";

//       const token = sessionStorage.getItem("authToken");
//       const headers = {};
//       if (token) {
//         headers["Authorization"] = `Bearer ${token}`;
//       }

//       const res = await fetch(url, {
//         method,
//         headers,
//         body: formData,
//       });

//       const data = await res.json();
//       console.log("Customer save response:", res.status, data);

//       if (!res.ok || data.success === false) {
//         setServerError(data.message || data.error || "Failed to save customer.");
//         return;
//       }

//       // Notify parent with created/updated customer object
//       if (onSave) {
//         onSave(data.data);
//       }
//     } catch (err) {
//       console.error("Error saving customer:", err);
//       setServerError("Something went wrong. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const isEditing = Boolean(form.id || form.customer_id);
//   const statusLabel = form.status
//     ? form.status.charAt(0).toUpperCase() + form.status.slice(1)
//     : "";

//   return (
//     <div className="customers-page cf-page">
//       {/* HEADER */}
//       <div className="cf-header">
//         <div className="cf-header-top">
//           <div className="cf-header-left">
//             <h1 className="cf-title">
//               {isEditing ? "Edit Customer" : "Add Customer"}
//             </h1>

//             <div className="cf-breadcrumbs">
//               <span className="breadcrumb-link">Dashboard</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-link">Customer List</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-current">Customer details</span>
//             </div>
//           </div>

//           <div className="cf-header-right">
//             <button
//               type="button"
//               className="btn btn-outline"
//               onClick={onCancel}
//               disabled={isSubmitting}
//             >
//               <FiX className="btn-icon" />
//               <span>Cancel</span>
//             </button>
//             <button
//               type="submit"
//               form="customer-form"
//               className="btn btn-primary"
//               disabled={isSubmitting}
//             >
//               <FiCheck className="btn-icon" />
//               <span>{isSubmitting ? "Saving..." : "Save Customer"}</span>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* BODY */}
//       <form id="customer-form" className="cf-form" onSubmit={handleSubmit}>
//         {serverError && (
//           <div className="cf-error-banner">{serverError}</div>
//         )}

//         <div className="cf-layout">
//           {/* LEFT: General Information */}
//           <div className="cf-left">
//             <div className="cf-card cf-card-general">
//               <h2 className="cf-card-title">General Information</h2>

//               <div className="cf-field">
//                 <label className="cf-label">
//                   Customer Name<span className="cf-required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className={`cf-input ${errors.name ? "cf-input-error" : ""}`}
//                   placeholder="Type customer name here..."
//                   value={form.name}
//                   onChange={(e) => handleChange("name", e.target.value)}
//                 />
//                 {errors.name && (
//                   <div className="cf-error-text">{errors.name}</div>
//                 )}
//               </div>

//               <div className="cf-row">
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     E-mail ID<span className="cf-required">*</span>
//                   </label>
//                   <input
//                     type="email"
//                     className={`cf-input ${
//                       errors.email ? "cf-input-error" : ""
//                     }`}
//                     placeholder="Type customer mail id here..."
//                     value={form.email}
//                     onChange={(e) => handleChange("email", e.target.value)}
//                   />
//                   {errors.email && (
//                     <div className="cf-error-text">{errors.email}</div>
//                   )}
//                 </div>
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     Phone Number<span className="cf-required">*</span>
//                   </label>
//                   <input
//                     type="tel"
//                     className={`cf-input ${
//                       errors.phone ? "cf-input-error" : ""
//                     }`}
//                     placeholder="Enter customer phone number here..."
//                     value={form.phone}
//                     onChange={(e) => handleChange("phone", e.target.value)}
//                   />
//                   {errors.phone && (
//                     <div className="cf-error-text">{errors.phone}</div>
//                   )}
//                 </div>
//               </div>

//               {/* State & District */}
//               <div className="cf-row">
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     State<span className="cf-required">*</span>
//                   </label>
//                   <select
//                     className={`cf-input ${
//                       errors.state ? "cf-input-error" : ""
//                     }`}
//                     value={form.state}
//                     onChange={(e) => handleChange("state", e.target.value)}
//                   >
//                     <option value="">Select State</option>
//                     {INDIAN_STATES.map((s) => (
//                       <option
//                         key={s}
//                         value={s}
//                         disabled={s !== "Karnataka"} // only Karnataka active
//                       >
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                   {errors.state && (
//                     <div className="cf-error-text">{errors.state}</div>
//                   )}
//                 </div>
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     District<span className="cf-required">*</span>
//                   </label>
//                   <select
//                     className={`cf-input ${
//                       errors.district ? "cf-input-error" : ""
//                     }`}
//                     value={form.district}
//                     onChange={(e) =>
//                       handleChange("district", e.target.value)
//                     }
//                     disabled={!form.state || form.state !== "Karnataka"}
//                   >
//                     <option value="">
//                       {form.state === "Karnataka"
//                         ? "Select District"
//                         : "Select Karnataka first"}
//                     </option>
//                     {districtOptions.map((d) => (
//                       <option key={d} value={d}>
//                         {d}
//                       </option>
//                     ))}
//                   </select>
//                   {errors.district && (
//                     <div className="cf-error-text">{errors.district}</div>
//                   )}
//                 </div>
//               </div>

//               {/* Taluk & Panchayat */}
//               <div className="cf-row">
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     Taluk<span className="cf-required">*</span>
//                   </label>
//                   <select
//                     className={`cf-input ${
//                       errors.taluk ? "cf-input-error" : ""
//                     }`}
//                     value={form.taluk}
//                     onChange={(e) => handleChange("taluk", e.target.value)}
//                     disabled={!form.district}
//                   >
//                     <option value="">
//                       {form.district ? "Select Taluk" : "Select district first"}
//                     </option>
//                     {talukOptions.map((t) => (
//                       <option key={t} value={t}>
//                         {t}
//                       </option>
//                     ))}
//                   </select>
//                   {errors.taluk && (
//                     <div className="cf-error-text">{errors.taluk}</div>
//                   )}
//                 </div>
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     Panchayat<span className="cf-required">*</span>
//                   </label>
//                   <select
//                     className={`cf-input ${
//                       errors.panchayat ? "cf-input-error" : ""
//                     }`}
//                     value={form.panchayat}
//                     onChange={(e) =>
//                       handleChange("panchayat", e.target.value)
//                     }
//                     disabled={!form.taluk}
//                   >
//                     <option value="">
//                       {form.taluk ? "Select Panchayat" : "Select taluk first"}
//                     </option>
//                     {panchayatOptions.map((p) => (
//                       <option key={p} value={p}>
//                         {p}
//                       </option>
//                     ))}
//                   </select>
//                   {errors.panchayat && (
//                     <div className="cf-error-text">{errors.panchayat}</div>
//                   )}
//                 </div>
//               </div>

//               <div className="cf-row">
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">Landmark</label>
//                   <input
//                     type="text"
//                     className="cf-input"
//                     placeholder="Type here"
//                     value={form.landmark}
//                     onChange={(e) =>
//                       handleChange("landmark", e.target.value)
//                     }
//                   />
//                 </div>
//                 <div className="cf-field cf-col">
//                   <label className="cf-label">
//                     Pin Code<span className="cf-required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`cf-input ${
//                       errors.pincode ? "cf-input-error" : ""
//                     }`}
//                     placeholder="Enter pin code"
//                     value={form.pincode}
//                     onChange={(e) =>
//                       handleChange("pincode", e.target.value)
//                     }
//                   />
//                   {errors.pincode && (
//                     <div className="cf-error-text">{errors.pincode}</div>
//                   )}
//                 </div>
//               </div>

//               <div className="cf-field">
//                 <label className="cf-label">Customer Note</label>
//                 <textarea
//                   rows={4}
//                   className="cf-textarea"
//                   placeholder="Type here"
//                   value={form.note}
//                   onChange={(e) => handleChange("note", e.target.value)}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* RIGHT SIDE: Status & Profile Image */}
//           <div className="cf-right">
//             {/* Status card */}
//             <div className="cf-card cf-card-status">
//               <div className="cf-card-status-header">
//                 <h2 className="cf-card-title">Status</h2>
//                 <span className={`cf-status-pill cf-status-${form.status}`}>
//                   {statusLabel}
//                 </span>
//               </div>

//               <div className="cf-field">
//                 <label className="cf-label">Status</label>
//                 <select
//                   className="cf-input"
//                   value={form.status}
//                   onChange={(e) => handleChange("status", e.target.value)}
//                 >
//                   {STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s.charAt(0).toUpperCase() + s.slice(1)}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Profile image card */}
//             <div className="cf-card cf-card-avatar">
//               <h2 className="cf-card-title">Profile Image</h2>

//               <div className="cf-avatar-dropzone" onClick={openFilePicker}>
//                 {form.avatarUrl ? (
//                   <div className="cf-avatar-preview">
//                     <img src={form.avatarUrl} alt={form.name || "Avatar"} />
//                   </div>
//                 ) : (
//                   <div className="cf-avatar-empty">
//                     <FiImage className="cf-avatar-empty-icon" />
//                     <p className="cf-avatar-empty-text">
//                       Drag and drop image here, or click add.
//                     </p>
//                   </div>
//                 )}

//                 <input
//                   type="file"
//                   accept="image/*"
//                   ref={fileInputRef}
//                   onChange={handleAvatarSelect}
//                   style={{ display: "none" }}
//                 />
//               </div>

//               <button
//                 type="button"
//                 className="btn cf-btn-light cf-btn-full"
//                 onClick={openFilePicker}
//                 disabled={isSubmitting}
//               >
//                 <FiUploadCloud className="btn-icon" />
//                 <span>Add Image</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default CustomerForm;

import React, { useEffect, useMemo, useRef, useState } from "react";
import "./customerForm.css";
import {
  FiChevronRight,
  FiX,
  FiCheck,
  FiFileText,
  FiImage,
  FiUploadCloud,
} from "react-icons/fi";

const STATUS_OPTIONS = ["active", "inactive", "blocked"];
const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

const normalizeForm = (data) => ({
  ...data,
  note: data?.note ?? "",
  dairy: data?.dairy ?? "", // ✅ NEW
});

const CustomerForm = ({ initialData, onCancel, onSave }) => {
const [form, setForm] = useState(() => normalizeForm(initialData));
  const [errors, setErrors] = useState({});
  const [avatarFile, setAvatarFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState("");
  const fileInputRef = useRef(null);

  // Location data from API
  const [districts, setDistricts] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);

  const isEditing = Boolean(form.id);

  useEffect(() => {
  setForm(normalizeForm(initialData));
  setErrors({});
  setAvatarFile(null);
  setServerError("");
}, [initialData]);

  // Fetch districts on mount
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/locations/districts`);
        const data = await res.json();
        if (data.success) {
          setDistricts(data.data || []);
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };

    fetchDistricts();
  }, []);

  // Fetch taluks when district changes
  useEffect(() => {
    const fetchTaluks = async () => {
      if (!form.district || form.district === "") {
        setTaluks([]);
        return;
      }

      setLoadingLocations(true);
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/locations/taluks?district=${encodeURIComponent(form.district)}`
        );
        const data = await res.json();
        if (data.success) {
          setTaluks(data.data || []);
        }
      } catch (err) {
        console.error("Error fetching taluks:", err);
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchTaluks();
  }, [form.district]);

  const districtOptions = useMemo(() => {
    return districts.map(d => d.name);
  }, [districts]);

  const talukOptions = useMemo(() => {
    return taluks.map(t => t.name);
  }, [taluks]);

  const handleChange = (field, value) => {
    setForm((prev) => {
      const updated = { ...prev, [field]: value };

      if (!isEditing) {
        if (field === "district") {
          updated.taluk = "";
          updated.panchayat = "";
        }
        if (field === "taluk") {
          updated.panchayat = "";
        }
      }

      return updated;
    });
  };

  // Profile image handlers
  const handleAvatarSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    setAvatarFile(file);
    setForm((prev) => ({ ...prev, avatarUrl: url }));
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  // Helper to get full image URL
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return "";
    if (imageUrl.startsWith("http") || imageUrl.startsWith("blob:")) {
      return imageUrl;
    }
    return `${API_BASE_URL}${imageUrl}`;
  };

  const validate = () => {
    const err = {};

    if (!isEditing && (!form.panchayat || !form.panchayat.trim())) {
      err.panchayat = "Panchayat name is required.";
    }

    if (!form.district) err.district = "District is required.";
    if (!form.taluk) err.taluk = "Taluk is required.";

    if (form.email && form.email.trim() && !/^\S+@\S+\.\S+$/.test(form.email)) {
      err.email = "Enter a valid email.";
    }

    if (form.phone && form.phone.trim()) {
      const cleanPhone = form.phone.replace(/\D/g, "");
      if (cleanPhone.length !== 10) {
        err.phone = "Enter a valid 10 digit phone number.";
      }
    }

    if (form.pincode && form.pincode.trim()) {
      if (!/^\d{6}$/.test(form.pincode.replace(/\D/g, ""))) {
        err.pincode = "Enter a valid 6 digit pin code.";
      }
    }

    return err;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const v = validate();
  if (Object.keys(v).length) {
    setErrors(v);
    return;
  }

  setErrors({});
  setServerError("");
  setIsSubmitting(true);

  try {
    let response;

    if (isEditing) {
      // Check if we have a file to upload
      const hasFile = avatarFile !== null;
      
      if (hasFile) {
        // Use FormData when there's an image
        const formData = new FormData();
        
        // Only append non-empty values
        const email = form.email?.trim();
        const phone = form.phone?.trim();
        const pincode = form.pincode?.trim();
        const address = form.landmark?.trim() || form.address?.trim();
        const status = form.status || "active";
        const note = form.note?.trim();
        const dairy = form.dairy?.trim(); 

        if (email) formData.append("email", email);
        if (phone) formData.append("phone_number", phone);
        if (pincode) formData.append("pincode", pincode);
        if (address) formData.append("address", address);
        if (status) formData.append("status", status);
        if (note) formData.append("note", note);
        if (dairy) formData.append("dairy", dairy);
        
        formData.append("image", avatarFile);

        // Debug log
        console.log('Sending FormData with image:');
        for (let [key, value] of formData.entries()) {
          console.log(`  ${key}:`, value instanceof File ? value.name : value);
        }

        response = await fetch(`${API_BASE_URL}/api/panchayaths/update/${form.id}`, {
          method: "PATCH",
          body: formData,
        });
      } else {
        // Use JSON when there's no image
        const updateData = {};
        
        const email = form.email?.trim();
        const phone = form.phone?.trim();
        const pincode = form.pincode?.trim();
        const address = form.landmark?.trim() || form.address?.trim();
        const status = form.status || "active";
        const note = form.note?.trim();
        const dairy = form.dairy?.trim();  

        // Only add non-empty fields
        if (email) updateData.email = email;
        if (phone) updateData.phone_number = phone;
        if (pincode) updateData.pincode = pincode;
        if (address) updateData.address = address;
        if (status) updateData.status = status;
        if (note) updateData.note = note;
        if (dairy) updateData.dairy = dairy;

        console.log('Sending JSON data:', updateData);

        // Check if there's anything to update
        if (Object.keys(updateData).length === 0) {
          setServerError("No changes to save");
          setIsSubmitting(false);
          return;
        }

        response = await fetch(`${API_BASE_URL}/api/panchayaths/update/${form.id}`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updateData),
        });
      }

      const data = await response.json();
      console.log("Panchayat update response:", response.status, data);

      if (!response.ok || data.success === false) {
        setServerError(data.message || data.error || "Failed to update panchayat.");
        return;
      }

      if (onSave) {
        onSave(data.data);
      }
    } else {
      // CREATE new panchayat
      const hasFile = avatarFile !== null;

      if (hasFile) {
        const formData = new FormData();
        formData.append("name", form.panchayat?.trim() || "");
        formData.append("district", form.district || "");
        formData.append("taluk", form.taluk || "");
        
        const email = form.email?.trim();
        const phone = form.phone?.trim();
        const pincode = form.pincode?.trim();
        const address = form.landmark?.trim();
        const note = form.note?.trim();
        const dairy = form.dairy?.trim();

        if (email) formData.append("email", email);
        if (phone) formData.append("phone_number", phone);
        if (pincode) formData.append("pincode", pincode);
        if (address) formData.append("address", address);
        formData.append("status", form.status || "active");
        if (note) formData.append("note", note);
        formData.append("image", avatarFile);
        if (dairy) formData.append("dairy", dairy);

        response = await fetch(`${API_BASE_URL}/api/panchayaths/create`, {
          method: "POST",
          body: formData,
        });
      } else {
        const createData = {
          name: form.panchayat?.trim(),
          district: form.district,
          taluk: form.taluk,
          status: form.status || 'active'
        };
        
        const email = form.email?.trim();
        const phone = form.phone?.trim();
        const pincode = form.pincode?.trim();
        const address = form.landmark?.trim();
        const note = form.note?.trim();
        const dairy = form.dairy?.trim(); 

        if (email) createData.email = email;
        if (phone) createData.phone_number = phone;
        if (pincode) createData.pincode = pincode;
        if (address) createData.address = address;
        if (note) createData.note = note;
        if (dairy) createData.dairy = dairy;  

        response = await fetch(`${API_BASE_URL}/api/panchayaths/create`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(createData),
        });
      }

      const data = await response.json();
      console.log("Panchayat create response:", response.status, data);

      if (!response.ok || data.success === false) {
        setServerError(data.message || data.error || "Failed to create panchayat.");
        return;
      }

      if (onSave) {
        onSave(data.data);
      }
    }
  } catch (err) {
    console.error("Error saving panchayat:", err);
    setServerError("Something went wrong. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

  const statusLabel = form.status
    ? form.status.charAt(0).toUpperCase() + form.status.slice(1)
    : "Active";

  // Determine which image URL to display
  const displayImageUrl = form.avatarUrl || (form.imageUrl ? getImageUrl(form.imageUrl) : null);

  return (
    <div className="customers-page cf-page">
      {/* HEADER */}
      <div className="cf-header">
        <div className="cf-header-top">
          <div className="cf-header-left">
            <h1 className="cf-title">
              {isEditing ? "Edit Panchayat" : "Add Panchayat"}
            </h1>

            <div className="cf-breadcrumbs">
              <span className="breadcrumb-link">Dashboard</span>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <span className="breadcrumb-link">Panchayat List</span>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <span className="breadcrumb-current">
                {isEditing ? "Edit Panchayat" : "Add Panchayat"}
              </span>
            </div>
          </div>

          <div className="cf-header-right">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              <FiX className="btn-icon" />
              <span>Cancel</span>
            </button>
            <button
              type="submit"
              form="customer-form"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              <FiCheck className="btn-icon" />
              <span>{isSubmitting ? "Saving..." : "Save Panchayat"}</span>
            </button>
          </div>
        </div>
      </div>

      {/* BODY */}
      <form id="customer-form" className="cf-form" onSubmit={handleSubmit}>
        {serverError && (
          <div className="cf-error-banner">{serverError}</div>
        )}

        <div className="cf-layout">
          {/* LEFT: General Information */}
          <div className="cf-left">
            <div className="cf-card cf-card-general">
              <h2 className="cf-card-title">Panchayat Information</h2>

              {/* District & Taluk Selection */}
              <div className="cf-row">
                <div className="cf-field cf-col">
                  <label className="cf-label">
                    District<span className="cf-required">*</span>
                  </label>
                  <select
                    className={`cf-input ${errors.district ? "cf-input-error" : ""}`}
                    value={form.district || ""}
                    onChange={(e) => handleChange("district", e.target.value)}
                    disabled={isEditing}
                  >
                    <option value="">Select District</option>
                    {districtOptions.map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                  {errors.district && (
                    <div className="cf-error-text">{errors.district}</div>
                  )}
                </div>

                <div className="cf-field cf-col">
                  <label className="cf-label">
                    Taluk<span className="cf-required">*</span>
                  </label>
                  <select
                    className={`cf-input ${errors.taluk ? "cf-input-error" : ""}`}
                    value={form.taluk || ""}
                    onChange={(e) => handleChange("taluk", e.target.value)}
                    disabled={!form.district || isEditing}
                  >
                    <option value="">
                      {form.district ? "Select Taluk" : "Select district first"}
                    </option>
                    {talukOptions.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  {errors.taluk && (
                    <div className="cf-error-text">{errors.taluk}</div>
                  )}
                  {loadingLocations && (
                    <div className="cf-loading-text">Loading taluks...</div>
                  )}
                </div>
              </div>

              {/* Panchayat Name */}
              <div className="cf-field">
                <label className="cf-label">
                  Panchayat Name<span className="cf-required">*</span>
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    className="cf-input cf-input-disabled"
                    value={form.name || form.panchayat || ""}
                    disabled
                    title="Panchayat name cannot be changed"
                  />
                ) : (
                  <input
                    type="text"
                    className={`cf-input ${errors.panchayat ? "cf-input-error" : ""}`}
                    placeholder="Enter panchayat name..."
                    value={form.panchayat || ""}
                    onChange={(e) => handleChange("panchayat", e.target.value)}
                    disabled={!form.taluk}
                  />
                )}
                {errors.panchayat && (
                  <div className="cf-error-text">{errors.panchayat}</div>
                )}
                {!isEditing && !form.taluk && (
                  <div className="cf-help-text">Select district and taluk first</div>
                )}
              </div>

              {/* Email & Phone */}
              <div className="cf-row">
                <div className="cf-field cf-col">
                  <label className="cf-label">E-mail ID</label>
                  <input
                    type="email"
                    className={`cf-input ${errors.email ? "cf-input-error" : ""}`}
                    placeholder="Enter email address..."
                    value={form.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                  />
                  {errors.email && (
                    <div className="cf-error-text">{errors.email}</div>
                  )}
                </div>
                <div className="cf-field cf-col">
                  <label className="cf-label">Phone Number</label>
                  <input
                    type="tel"
                    className={`cf-input ${errors.phone ? "cf-input-error" : ""}`}
                    placeholder="Enter phone number..."
                    value={form.phone || ""}
                    onChange={(e) => handleChange("phone", e.target.value)}
                  />
                  {errors.phone && (
                    <div className="cf-error-text">{errors.phone}</div>
                  )}
                </div>
              </div>

              {/* Address & Pincode */}
              <div className="cf-row">
                <div className="cf-field cf-col">
                  <label className="cf-label">Address</label>
                  <input
                    type="text"
                    className="cf-input"
                    placeholder="Enter address..."
                    value={form.landmark || form.address || ""}
                    onChange={(e) => handleChange("landmark", e.target.value)}
                  />
                </div>
                <div className="cf-field cf-col">
                  <label className="cf-label">Pin Code</label>
                  <input
                    type="text"
                    className={`cf-input ${errors.pincode ? "cf-input-error" : ""}`}
                    placeholder="Enter pin code..."
                    value={form.pincode || ""}
                    onChange={(e) => handleChange("pincode", e.target.value)}
                  />
                  {errors.pincode && (
                    <div className="cf-error-text">{errors.pincode}</div>
                  )}
                </div>
              </div>

              {/* Note + Dairy */}
<div className="cf-row">
  {/* Customer Note */}
  <div className="cf-field cf-col">
    <label className="cf-label">
      <FiFileText
        className="cf-label-icon"
        style={{ marginRight: "6px", verticalAlign: "middle" }}
      />
      Customer Note
    </label>
    <textarea
      rows={4}
      className="cf-textarea"
      placeholder="Add any notes about this panchayat..."
      value={form.note}
      onChange={(e) => handleChange("note", e.target.value)}
    />
  </div>

  {/* Diary */}
  <div className="cf-field cf-col">
    <label className="cf-label">
      <FiFileText
        className="cf-label-icon"
        style={{ marginRight: "6px", verticalAlign: "middle" }}
      />
      Diary
    </label>
    <textarea
      rows={4}
      className="cf-textarea"
      placeholder="Add dairy details..."
      value={form.dairy}
      onChange={(e) => handleChange("dairy", e.target.value)}
    />
  </div>
</div>
            </div>
          </div>

          {/* RIGHT SIDE: Status & Profile Image */}
          <div className="cf-right">
            {/* Status card */}
            <div className="cf-card cf-card-status">
              <div className="cf-card-status-header">
                <h2 className="cf-card-title">Status</h2>
                <span className={`cf-status-pill cf-status-${form.status || 'active'}`}>
                  {statusLabel}
                </span>
              </div>

              <div className="cf-field">
                <label className="cf-label">Status</label>
                <select
                  className="cf-input"
                  value={form.status || "active"}
                  onChange={(e) => handleChange("status", e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s.charAt(0).toUpperCase() + s.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Profile image card */}
            <div className="cf-card cf-card-avatar">
              <h2 className="cf-card-title">Profile Image</h2>

              <div className="cf-avatar-dropzone" onClick={openFilePicker}>
                {displayImageUrl ? (
                  <div className="cf-avatar-preview">
                    <img src={displayImageUrl} alt={form.name || form.panchayat || "Avatar"} />
                  </div>
                ) : (
                  <div className="cf-avatar-empty">
                    <FiImage className="cf-avatar-empty-icon" />
                    <p className="cf-avatar-empty-text">
                      Drag and drop image here, or click add.
                    </p>
                  </div>
                )}

                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleAvatarSelect}
                  style={{ display: "none" }}
                />
              </div>

              <button
                type="button"
                className="btn cf-btn-light cf-btn-full"
                onClick={openFilePicker}
                disabled={isSubmitting}
              >
                <FiUploadCloud className="btn-icon" />
                <span>{displayImageUrl ? "Change Image" : "Add Image"}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CustomerForm;